import {
  addDoc,
  deleteDoc,
  doc,
  getDocs,
  query,
  updateDoc,
  where,
  collection,
  getDoc,
  setDoc,
} from "firebase/firestore";
import { ContributorsInvitesRef, ContributorsRef, db } from "../../../firebase";
// import { id } from "date-fns/locale";

export const contributorsSearch = (array, keyword) => {
  const searchTerm = keyword.toLowerCase();
  return array.filter((value) => {
    return (
      (value.firstName &&
        value.firstName.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.id &&
        value.id.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.lastName &&
        value.lastName.toLowerCase().match(new RegExp(searchTerm, "g"))) ||
      (value.userName &&
        value.userName.toLowerCase().match(new RegExp(searchTerm, "g")))
    );
  });
};

export const searchUsersFromFirebase = async (searchTerm) => {
  // Construct a query with multiple conditions
  // Firestore currently doesn't support OR queries natively,
  // so we need to perform multiple queries and then merge the results.
  const queries = [
    query(ContributorsRef, where("firstName", "==", searchTerm)),
    query(ContributorsRef, where("lastName", "==", searchTerm)),
    query(ContributorsRef, where("email", "==", searchTerm)),
    query(ContributorsRef, where("phone", "==", searchTerm)),
  ];

  // Execute each query and gather the results
  const queryResults = await Promise.all(queries.map((q) => getDocs(q)));

  const users = queryResults
    .flatMap((result) => {
      return result.docs.map((doc) => ({ ...doc.data(), id: doc.id }));
    })
    .filter((user, index, self) => {
      const firstIndex = self.findIndex((u) => u.email === user.email);

      return index === firstIndex;
    });
  return users;
};

export const getAllContributors = async (orgId) => {
  try {
    const queryRef = query(
      ContributorsRef,
      where("organizations", "array-contains", orgId)
    );
    const response = await getDocs(queryRef);

    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getFilterContributors = async (
  filterOptions,
  setLoading,
  handleFilterModalClose,
  organization
) => {
  setLoading(true);
  const deduplicate = (arr) => {
    const uniqueIds = new Set();
    const uniqueDocs = [];
    arr.forEach((doc) => {
      if (!uniqueIds.has(doc.id)) {
        uniqueIds.add(doc.id);
        uniqueDocs.push(doc);
      }
    });
    console.log("results:", uniqueDocs);
    handleFilterModalClose();
    return uniqueDocs;
  };

  try {
    // Define the reference to your QuickTales collection
    let results = [];

    const statusOptions = filterOptions.length > 0 ? filterOptions : [null];

    for (const status of statusOptions) {
      let queries = [];

      if (status !== null) {
        queries.push(where("status", "==", status));
      }

      if (organization) {
        queries.push(where("organization", "==", organization));
        //   // where("organization", "array-contains", organization)
      }

      if (queries.length > 0) {
        const q = query(ContributorsInvitesRef, ...queries);
        const querySnapshot = await getDocs(q);
        console.log("results:", querySnapshot.docs[0]?.data());

        const fetchDetailsPromises = querySnapshot.docs.map(async (doc) => {
          return {
            id: doc.id,
            ...doc.data(),
          };
        });

        // Wait for all fetches to complete
        const queryResults = await Promise.all(fetchDetailsPromises);
        results = results.concat(queryResults);
      }
    }

    // // Start with a query that filters QuickTales by the specific organization
    // let baseQuery = query(
    //   ContributorsInvitesRef,
    //   where("organization", "==", organization)
    //   // where("organization", "array-contains", organization)
    // );

    // // Apply 'Who Can Listen' filters
    // filterOptions.forEach((option) => {
    //   baseQuery = query(baseQuery, where("status", "==", option));
    // });

    // // Execute the query
    // const querySnapshot = await getDocs(baseQuery);

    // // Process each document
    // for (const doc of querySnapshot.docs) {
    //   // console.log("results::::", doc.data());
    //   results.push({
    //     id: doc.id,
    //     ...doc.data(),
    //   });
    // }

    // Deduplicate the results if necessary
    const deduplicatedResults = deduplicate(results);
    handleFilterModalClose();
    return deduplicatedResults;
  } catch (error) {
    console.error("Error filtering Contributors:", error);
    setLoading(false);
    return []; // Return an empty array in case of error
  } finally {
    setLoading(false);
  }
};

export const getAllContributorsInvites = async (orgId) => {
  try {
    const queryRef = query(
      ContributorsInvitesRef,
      where("organization", "==", orgId)
    );
    const response = await getDocs(queryRef);

    return response;
  } catch (error) {
    console.log("Error fetching data from Firestore:", error.message);
    // console.error("Error fetching data from Firestore:", error.message);
    return [];
  }
};

export const getContributorInvite = async (id) => {
  const contributorsRef = doc(db, "contributorsInvites", id);
  return await getDoc(contributorsRef);
};
export const deleteContributor = async (id) => {
  const contributorsRef = doc(db, "users", id);
  return await deleteDoc(contributorsRef);
};
export const updateContributor = async (id, contributorDoc) => {
  try {
    const contributorsRef = doc(db, "users", id);
    return await updateDoc(contributorsRef, contributorDoc);
  } catch (error) {
    console.log("updating contributor:::", error);
  }
};

export const addContributorsInvites = async (data) => {
  return await addDoc(ContributorsInvitesRef, data);
};

export const deleteContributorInvite = async (id) => {
  const contributorsRef = doc(db, "contributorsInvites", id);
  return await deleteDoc(contributorsRef);
};

export const checkContributorInviteExist = async (email) => {
  const q = query(
    ContributorsInvitesRef,
    where("invitedUserEmail", "==", email)
  );

  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    const response = {
      data: querySnapshot.docs[0].data(),
      id: querySnapshot.docs[0].id,
      status: true,
    };
    return response;
  } else {
    return { status: false };
  }
};
export const checkUserExist = async (email) => {
  const usersRef = collection(db, "users");
  const q = query(usersRef, where("email", "==", email));

  const querySnapshot = await getDocs(q);
  if (!querySnapshot.empty) {
    const response = {
      data: querySnapshot.docs[0].data(),
      id: querySnapshot.docs[0].id,
      status: true,
    };
    return response;
  } else {
    return { status: false };
  }
};

export const createContributorDoc = async (data, id) => {
  let docRef = doc(db, "users", id);
  return await setDoc(docRef, data);
  // let docRef = doc(ContributorsRef, id)
  // return await setDoc(docRef, data);
};
export const addContributor = async (data) => {
  const usersRef = collection(db, "users");
  return await addDoc(usersRef, data);
};

export const updateContributorInvite = async (data, id) => {
  try {
    const contributorsRef = doc(db, "contributorsInvites", id);
    return await updateDoc(contributorsRef, data);
  } catch (error) {
    console.log("updting contributor invite:::", error);
  }
};

// //General Admin section functions

// export const getAllUsers = async () => {
//   try {
//     const response = await getDocs(ContributorsRef);
//     return response;
//   } catch (error) {
//     console.log("Error fetching data from Firestore:", error.message);
//     // console.error("Error fetching data from Firestore:", error.message);
//     return [];
//   }
// };
